import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import TextEditor from 'shared/form/TextEditor/TextEditor';
import EDIT_ICON from 'assets/img/edit-01.svg';
import HeadingWithIcon from 'pages/projects/kanban/shared/HeadingWithIcon';
import menuIcon from 'assets/img/menu-03.svg';
import style from './Description.module.css';
import { getPlainText } from 'utils/Helpers';
import arrowDown from 'assets/img/arrow-down.svg';

export default function Description({
  isInstruction = false,
  description,
  handleSubmitDescription,
  viewMode,
  handleDescriptionChange,
  setShowTextEditor,
  showTextEditor,
  isDesc,
  setUpdatedDesc,
  isSubtask,
  parentId
}) {
  const [value, setValue] = useState(description || '');
  const [expanded, setExpanded] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const contentRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    setValue(description);
  }, [description, showTextEditor]);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkHeight = () => {
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight || '20');
      const maxLines = 18;
      const maxHeight = lineHeight * maxLines;

      if (el.scrollHeight > maxHeight) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    checkHeight();

    // Watch for images loading
    const images = el.querySelectorAll('img');
    images.forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', checkHeight);
        img.addEventListener('error', checkHeight);
      }
    });

    return () => {
      images.forEach((img) => {
        img.removeEventListener('load', checkHeight);
        img.removeEventListener('error', checkHeight);
      });
    };
  }, [description]);

  return (
    <div
      className={style.desc_hover}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}>
      {/* {description && ( */}
      <HeadingWithIcon
        icon={EDIT_ICON}
        heading={isInstruction ? 'Instructions' : 'Description'}
        isDesc={showTextEditor || !description ? false : isDesc}
        toggleDesc={() => (viewMode ? {} : setShowTextEditor(true))}
        showIcon={viewMode ? false : isHovering}
      />
      {/* )} */}
      <div className={style.desciption_text_editor_wrapper}>
        {showTextEditor ? (
          <>
            <TextEditor
              value={value}
              onChange={(data) => {
                setValue(data);
                if (setUpdatedDesc) {
                  setUpdatedDesc(data);
                }
              }}
              isSubtask={isSubtask}
              parentId={parentId}
            />
            <div className={style.button_group}>
              <Button
                variant="success"
                onClick={() => {
                  setShowTextEditor(false);
                  handleSubmitDescription(value);
                }}>
                Save
              </Button>
              <Button
                variant="link"
                onClick={() => {
                  setShowTextEditor(false);
                  setValue('');
                  if (setUpdatedDesc) {
                    setUpdatedDesc(description);
                  }
                }}>
                Cancel
              </Button>
            </div>
          </>
        ) : (
          <div
          style={{width: !description ? "fit-content" : "100%"}}
            onClick={() =>
              viewMode || isDesc ? (!description ? setShowTextEditor(true) : {}) : setShowTextEditor(true)
            }>
            {description ? (
              <div className={`${style.description_info} ${style.description_list}`}>
                <div
                  ref={contentRef}
                  className={style.description_content}
                  style={{
                    maxHeight: expanded ? 'none' : '40vh',
                    overflow: 'hidden',
                    transition: 'max-height 0.3s ease'
                  }}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
                {showButton && (
                  <button
                    className={style.show_more_btn}
                    onClick={(e) => {
                      e.stopPropagation();
                      setExpanded(!expanded);
                    }}>
                    <img
                      src={arrowDown}
                      className={`${style.arrow_showmore} ${expanded ? style.rotated : ''}`}
                      alt=""
                    />
                    {expanded ? 'Show less' : 'Show more'}
                  </button>
                )}
              </div>
            ) : isInstruction ? (
              <textarea
                placeholder={`Add a more detailed ${isInstruction ? 'instructions' : 'description'}...`}
                value={description || ''}
                readOnly={true}
              />
            ) : (
              <div className={style.nodata_description_box}>Add a more detailed description...</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
